import type {
  SiteBanner,
  SiteBannerResponse,
} from "@repo/sitecore-lib/queries";
import type {
  BannerContent,
  BannerCarouselContent,
} from "./global-banner.types";

const getFieldValue = (field: { value?: string } | undefined): string => {
  return field?.value || "";
};

const appendCtaRefFragment = (href: string, ctaRef: string): string => {
  const [base, existingFragment] = href.split("#");
  const fragment = existingFragment
    ? `${existingFragment}&ctaref-${ctaRef}`
    : `ctaref-${ctaRef}`;
  return `${base}#${fragment}`;
};

export const transformBannerContent = (banner: SiteBanner): BannerContent => {
  const ctaRef = getFieldValue(banner.ctaRef) || undefined;
  const originalHref = banner.ctaUrl?.href;
  const hasHref =
    typeof originalHref === "string" && originalHref.trim().length > 0;
  const ctaUrl =
    banner.ctaUrl && ctaRef && hasHref
      ? {
          ...banner.ctaUrl,
          href: appendCtaRefFragment(originalHref, ctaRef),
        }
      : banner.ctaUrl;

  return {
    desktop: {
      title: getFieldValue(banner.desktopTitle),
      subtitle: getFieldValue(banner.desktopSubtitle),
      text: getFieldValue(banner.desktopText),
    },
    mobile: {
      title: getFieldValue(banner.mobileTitle),
      subtitle: getFieldValue(banner.mobileSubtitle),
      text: getFieldValue(banner.mobileText),
    },
    ctaUrl,
    ctaRef,
    theme: getFieldValue(banner.theme),
    code: getFieldValue(banner.code),
  };
};

export const getBannerContentFromResponse = (
  response: SiteBannerResponse | null,
): BannerCarouselContent => {
  const banners = response?.data?.container?.carousel?.banners;

  if (!banners || banners.length === 0) {
    return [];
  }

  return banners.map((banner) => transformBannerContent(banner));
};
